namespace Areas.Maintenance {
    "use strict";

    var selected: Selected = new Selected();
    var inspectorUserSelected: Selected = new Selected();
    var accessRequestUserSelected: Selected = new Selected();
    let userId: string;
    let runQuery: boolean = false;


    export function inspectorOnUserIDValueChanged(rowData, value) {
        if (value === undefined || value === null) {
            rowData.userId = null;
            rowData.inspectorEmail = null;
            rowData.inspectorLk = null;
            rowData.loginName = null;
            return;
        }

        if (!inspectorUserSelected.user.isActive) {
            DevExpress.ui.notify("The record cannot be updated. The user you selected has been disabled!", "error", 3000);
            return;
        }

        if (rowData.inspectorLk === null) {
           rowData.inspectorLk = inspectorUserSelected.user.displayName;
        }

        rowData.userId = inspectorUserSelected.user.userId;
        rowData.inspectorEmail = inspectorUserSelected.user.email;
        rowData.loginName = inspectorUserSelected.user.loginName;
    }

    export function inspectorUserLookupEditTemplate(cellElement, cellInfo) {
        return lookupEditTemplate("/Maintenance/Inspectors/Users", inspectorUserSelected)(cellElement, cellInfo);
    }

    export function inspectorUserLookupCellTemplate(cellElement, cellInfo) {
        return lookupCellTemplate(cellElement, cellInfo);
    }

    export function onUserIDValueChanged(rowData, value) {
        return userValueChanged(selected)(rowData, value);
    }

    export function userLookupEditTemplate(cellElement, cellInfo) {
        return lookupEditTemplate("/Maintenance/SystemUsers/Users", selected)(cellElement, cellInfo);
    }

    export function userLookupCellTemplate(cellElement, cellInfo) {
        return lookupCellTemplate(cellElement, cellInfo);
    }

    export function addInspectionTypeTree() {
        
        var catGrid = $('#CategoryGrid').dxDataGrid('instance');
        var categoryLk = catGrid.getSelectedRowKeys()[0];
        if (categoryLk == null) {
            DevExpress.ui.notify("You need to select a category first!", "warning", 2000);
            return;
        }

        var inspTypeGrid = $('#InspectionTypeGrid').dxDataGrid('instance');
        var inspTypeLk = inspTypeGrid.getSelectedRowKeys()[0];
        if (inspTypeLk == null) {
            DevExpress.ui.notify("You need to select an inspection type first!", "warning", 2000);
            return;
        }

        var subTypeGrid = $('#InspectionSubTypeGrid').dxDataGrid('instance');
        var subTypeLks = subTypeGrid.getSelectedRowKeys();
        if (subTypeLks.length === 0) {
            DevExpress.ui.notify("You need to select an inspection subtype first!", "warning", 2000);
            return;
        }

        var newData = {
            categoryLk: categoryLk,
            inspectionTypeLk: inspTypeLk,
            inspectionSubTypeLks: subTypeLks
        };

        var data = JSON.stringify(newData);
        var url = "/Maintenance/InspectionTypeTrees/Add";

        sendRequest(url, data, "POST", () => { $('#InspectionTypeTreeGrid').dxDataGrid("instance").refresh(); });
    }

    export function userSelected(e) {
        
        var userProjectGrid: DevExpress.ui.dxDataGrid = $('#UserProjectGrid').dxDataGrid('instance');
        var rightsGrid: DevExpress.ui.dxDataGrid = $('#RightsGrid').dxDataGrid('instance');
        var selectedRows = e.component.getSelectedRowsData();

        runQuery = true;
        userId = selectedRows[0].userId;
        Areas.refreshGrid("RightsGrid");

        var storeConfiguration = {
            "loadParams": { "userId": e.currentSelectedRowKeys[0] },
            "key": "inspectionProjectId",
            "loadUrl": "/Maintenance/UserProject/Get"
        };
        
        var dataSource = DevExpress.data.AspNet.createStore(storeConfiguration);
        userProjectGrid.option("dataSource", dataSource);
    }

    export function getUserId() {
        return userId;
    }

    export function canExecuteQuery() {
        return runQuery;
    }


    export function assignUser(e) {

        var userGrid: DevExpress.ui.dxDataGrid = $('#UserGrid').dxDataGrid('instance');
        var userProjectGrid: DevExpress.ui.dxDataGrid = $('#UserProjectGrid').dxDataGrid('instance');
        
        var newData = {
            userId: userGrid.getSelectedRowKeys()[0],
            inspectionProjectId: userProjectGrid.getSelectedRowKeys()[0]
        };

        var url = "/Maintenance/UserProject/Put";
        var data = JSON.stringify(newData);

        sendRequest(url, data, "PUT", () => {
            userProjectGrid.refresh();
            userGrid.refresh();            
        });

    }

    export function closeRequest(e) {
        var url = `/Maintenance/UserAccess/Close/${e}`;

        sendRequest(url, "", "PUT", () => { $('#RequestAccessGrid').dxDataGrid('instance').refresh(); });
    }

    export function closeLink(cellElement, cellInfo) {
        console.log(cellInfo.data);
        var fieldData = cellInfo.data.requestAccessId;
        var linkInfo = "<a href= '#' onclick='Areas.Maintenance.closeRequest(" + String(fieldData) + ")'>Close</a>";
        cellElement.html(linkInfo);
    }

    
    export function disableColumnEdit(columnName: string) {
        return function (e: any) {
            if (e.rowType !== "data" || !e.row.isEditing)
                return;
            if (e.column.dataField === columnName && !e.row.isNewRow)
                e.cellElement.find('input').prop('readonly', true);
        }
    }  


    export function accessRequestOnUserIDValueChanged(rowData, value) {
        if (value === undefined || value === null) {
            rowData.userId = null;
            rowData.email = null;
            rowData.displayUserName = null;
            return;
        }

        if (!accessRequestUserSelected.user.isActive) {
            DevExpress.ui.notify("The record cannot be updated. The user you selected has been disabled!", "error", 3000);
            return;
        }

        rowData.userId = accessRequestUserSelected.user.userId;
        rowData.email = accessRequestUserSelected.user.email;
        rowData.displayUserName = accessRequestUserSelected.user.displayUserName;
    }

    export function accessRequestUserLookupEditTemplate(cellElement, cellInfo) {
        return lookupEditTemplate("/Maintenance/UserAccess/GetActiveUsers", accessRequestUserSelected)(cellElement, cellInfo);
    }

    export function accessRequestLookupCellTemplate(cellElement, cellInfo) {
        return lookupCellTemplate(cellElement, cellInfo);
    }
    
}



